const env = import.meta.env;

export const IS_DEV = env.VITE_APP_ENV === "development";
export const IS_PROD = env.VITE_APP_ENV === "production";
export const IS_STAGING = env.VITE_APP_ENV === "staging";
